import { addDomEvent as d } from "./atoms-v2997.js";
import { addPointerInfo as e } from "./atoms-v2998.js";
function f(o, r, t, n) {
  return d(o, r, e(t), n);
}
export {
  f as addPointerEvent
};
